import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react';
import { Field } from 'redux-form';
import ValidatedFormInput from 'components/ValidatedFormInput';
import { renderRadioGroup } from './FormFieldRenderers';

const ExtraSubscriptionSection = ({
  bonusSubscriptionTypeValue,
  bonusSubscriptionTypes,
}) => {
  return (
    <div style={{ marginTop: '1.5em' }}>
      <Field
        name="bonus_subscription_type"
        component={renderRadioGroup}
        label="Extra Subscription Period"
        options={bonusSubscriptionTypes}
      />
      {bonusSubscriptionTypeValue === 'FIXED' && (
        <div style={{ marginTop: '1em', maxWidth: '300px' }}>
          <Form.Field>
            <label>
              Extra Months to Add <span style={{ color: 'red' }}>*</span>
            </label>
            <Field
              name="bonus_subscription_months"
              component={ValidatedFormInput}
              placeholder="0"
              type="number"
            />
          </Form.Field>
        </div>
      )}
      {bonusSubscriptionTypeValue === 'CUSTOM' && (
        <div style={{ marginTop: '1em' }}>
          <div
            style={{
              padding: '1em',
              backgroundColor: '#e3f2fd',
              borderRadius: '4px',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5em',
              marginBottom: '1em',
            }}
          >
            <span style={{ fontSize: '1.2em' }}>ⓘ</span>
            <span>
              Maximum allowed free months: <strong>3 months</strong> (configured
              in Approval module)
            </span>
          </div>
          <div style={{ maxWidth: '300px' }}>
            <Form.Field>
              <label>
                Maximum Extra Months <span style={{ color: 'red' }}>*</span>
              </label>
              <Field
                name="bonus_subscription_months"
                component={ValidatedFormInput}
                placeholder="0"
                type="number"
              />
            </Form.Field>
          </div>
        </div>
      )}
    </div>
  );
};

ExtraSubscriptionSection.propTypes = {
  bonusSubscriptionTypeValue: PropTypes.string,
  bonusSubscriptionTypes: PropTypes.array,
};

ExtraSubscriptionSection.defaultProps = {
  bonusSubscriptionTypeValue: 'NONE',
  bonusSubscriptionTypes: [],
};

export default ExtraSubscriptionSection;
